<div class="tds-container">
  <div class="tds-bar">
    <ion-icon name="lock-closed-outline" color="success"></ion-icon>
    <span class="tds-title">{{ 'CDC_AUTHENTICATION.THREE_DS.TITLE' | translate }}</span>
    <ion-button fill="clear" size="small" class="tds-close" (click)="cancelled.emit()"
      [attr.aria-label]="'BUTTONS.CLOSE' | translate">
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </div>

  <div class="tds-frame">
    @if($loading()){
    <ion-spinner name="crescent" class="tds-spinner"></ion-spinner>
    <p class="tds-loading-copy">{{ 'CDC_AUTHENTICATION.THREE_DS.LOADING' | translate }}</p>
    }
    @if($src(); as src){
    <iframe [src]="src" (load)="onFrameLoad()" title="3D Secure" allow="payment"
      sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
    }
  </div>

  <div class="tds-foot">
    @if($slow()){
    <p class="tds-slow">{{ 'CDC_AUTHENTICATION.THREE_DS.SLOW' | translate }}</p>
    <ion-button expand="block" size="default" (click)="openInBrowser.emit()">
      {{ 'CDC_AUTHENTICATION.THREE_DS.OPEN_IN_BROWSER' | translate }}
      <ion-icon slot="end" name="open-outline"></ion-icon>
    </ion-button>
    } @else {
    <!-- Finche' non e' passata la soglia: solo la rassicurazione. Nessun
         bottone per uscire, che qui sarebbe un invito ad abbandonare. -->
    <p class="tds-hint">{{ 'CDC_AUTHENTICATION.THREE_DS.HINT' | translate }}</p>
    }
  </div>
</div>
